import * as Sentry from '@sentry/browser'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import ENV from '../src/utils/environment'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { initStore } from './store'

if (ENV.SENTRY_ENABLE) {
  Sentry.init({
    dsn: 'https://e647e0afa49d4bd88c9f4de69b970756@sentry.attnte.ch/6',
    debug: true,
    environment: process.env.REACT_APP_ADMIN_STAGE
  })
}

ReactDOM.render(
  <Provider store={initStore}>
    <App />
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
